module.exports = __webpack_public_path__ + "img/company.a494110f.svg";